<template>
  <div>
    <div class="pickr-container" :class="{'active': getActiveCustomColor()}" />
  </div>
</template>
<script>
import { mapState } from 'vuex'
import Pickr from '@simonwep/pickr'
import debounce from 'debounce'
import SlideApi from '@/api/slide'
import Socket from '@/socket'
import Util from '@/util'
import Constant from '@/constant'
import EventBus from '@/eventBus'

// css
import '@simonwep/pickr/dist/themes/classic.min.css' // 'classic' theme

const pickerConfig = {
  swatches: [
    'rgba(255, 255, 255, 1)',
    'rgba(233, 30, 99, 1)',
    'rgba(156, 39, 176, 1)',
    'rgba(103, 58, 183, 1)',
    'rgba(63, 81, 181, 1)',
    'rgba(33, 150, 243, 1)',
    'rgba(3, 169, 244, 1)',
    'rgba(0, 188, 212, 1)',
    'rgba(0, 150, 136, 1)',
    'rgba(76, 175, 80, 1)',
    'rgba(139, 195, 74, 1)',
    'rgba(205, 220, 57, 1)',
    'rgba(255, 235, 59, 1)',
    'rgba(49, 49, 49, 1)',
  ],

  components: {
    preview: true,
    opacity: true,
    hue: true,

    interaction: {
      hex: false,
      rgba: false,
      input: true,
      hsva: false,
      clear: false,
    },
  },
}
export default {
  props: {
    disableUpdateBaseColor: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      pickr: null,
      isDisableUpdateWatch: false,
    }
  },
  computed: {
    ...mapState({
      baseColour: (state) => state.slideActive.baseColour,
    }),
  },
  watch: {
    baseColour() {
      if (this.ignoreColorPickerMounted) return
      this.isDisableUpdateWatch = true
      this.pickr.setColor(this.baseColour)
      this.isDisableUpdateWatch = false
    },
  },
  destroyed() {
    if (this.pickr) {
      this.pickr.destroyAndRemove()
    }
  },
  mounted() {
    if (this.ignoreColorPickerMounted) return
    const self = this
    const pickrContainer = this.$el.querySelector('.pickr-container')
    const el = document.createElement('p')
    pickrContainer.appendChild(el)

    if (this.pickr) {
      this.pickr.destroyAndRemove()
    }
    this.pickr = new Pickr(
      {
        el,
        theme: 'nano',
        default: this.baseColour || '',
        ...pickerConfig,
      },
    )

    this.pickr.on('change', async (color) => {
      if (this.isDisableUpdateWatch) return
      const hex = color.toHEXA().toString()
      this.pickr.setColor(hex)
      await self.updateSlide({
        baseColour: hex,
      })
    })
    this.pickr.on('save', async (color) => {
      if (this.isDisableUpdateWatch) return
      const hex = color.toHEXA().toString()
      await self.updateSlide({
        baseColour: hex,
      })
    })

    setTimeout(() => {
      // Prevent deselect from draggable, dispatch touchcancel to replace mouseup event
      const el = document.querySelector('.pcr-app')
      if (el) {
        el.addEventListener('mouseup', (e) => {
          document.dispatchEvent(new Event('touchcancel'))
          e.stopPropagation()
        })
      }
    }, 0)
  },

  methods: {
    getActiveCustomColor() {
      return !Constant.defaultBaseColour.some((item) => {
        return item.color === this.$store.getters.selectedSlide.baseColour
      })
    },

    updateSlide: debounce(async function (payload) {
      if (this.disableUpdateBaseColor) return
      Util.mixpanelTracking(
        'Slide',
        'Slide update base colour',
        payload.baseColour,
      )

      payload.presentationId = this.$store.state.presentation.id
      payload.accessCode = this.$store.state.presentation.uniqueAccessCode
      payload.socketId = Socket.getSocketId()
      payload.presenting = this.$store.getters.isPresenting || this.$store.getters.isBackstage

      const appliedSlides = this.$store.getters.selectedSlides

      this.$store.dispatch('updateSlideActive', payload)

      if (payload.baseColour) {
        EventBus.$emit('eventHandleSetValueTransition')
      }

      const slides = appliedSlides.map((slide) => ({
        id: slide.id,
        ...payload,
      }))
      await SlideApi.updateSlides({
        presentationId: this.$route.params.id,
        slides,
      })

      appliedSlides.forEach((slide) => {
        Constant.commonSlideAttributes.forEach((attr) => {
          if (payload[attr] !== undefined) {
            slide[attr] = payload[attr]
          }
        })
      })
    }, 300),
  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variable.scss";
@import "@/assets/scss/style.scss";

.pickr-container {
  &.active {
    & ::v-deep .pickr .pcr-button {
      border: 1px solid $primary-color !important;
      box-shadow: 0 0 0 2px $primary-color !important;
    }
  }
}
</style>
